import React from "react";
import logo from "../../assets/images/tell-logo-white.png";
import footerMap from "../../assets/images/footer-map.png";

const Footer = () => {
  return (
    <footer className="footer-area bg-color">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-sm-6">
            <div className="single-footer-widget">
              <a href="/" className="logo">
                <img src={logo} alt="logo" />
              </a>
              <h5>PSD2 the Easy, Cost Effective & Flexible way.</h5>
              <p><br />Headquarters:</p>
              <p>57C Telfords Yard, 6-8 The Highway,
                <br />
                Wapping, London, E1W 2BS,
                <br />
                United Kingdom
              </p>
              <p>Email: info@tell.money</p>
              <ul className="social-link">
                <li>
                  <a
                    href="https://www.linkedin.com/company/tell-money"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="bx bxl-linkedin"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-lg-2 col-sm-6"></div>

          <div className="col-lg-2 col-sm-6"></div>

          
        </div>
      </div>

      <div className="footer-map">
        <img src={footerMap} alt="footer-logo" />
      </div>
    </footer>
  );
};

export default Footer;
